<cu-dynamic-page-workflow-progress class="ww-position--sticky" [page]="page" [flow]="flow"></cu-dynamic-page-workflow-progress>
<cu-dynamic-page-layout [page]="page" [flow]="flow">
  <div page-body>
    <cu-dynamic-page-header [page]="page" [flow]="flow"></cu-dynamic-page-header>
    <cu-dynamic-page-alert [page]="page" [flow]="flow"></cu-dynamic-page-alert>
    <cu-dynamic-page-validation [page]="page" [flow]="flow"></cu-dynamic-page-validation>
    <cu-dynamic-page-cards [page]="page" [flow]="flow"></cu-dynamic-page-cards>
    <div class="bl-font-color--black" *ngIf="page.helper.isPageComplete && checklistEnabled">
      <div class=" bl-margin-bottom--40">
        <h1
          class="bl-font-size--28 bl-font-weight--900 bl-font-color--black bl-text-transform--capitalize bl-display--block">
          {{'eligibility/heading'|dictionary}} </h1>
        <div>{{'eligibility/description'|dictionary}}</div>
      </div>
      <div class="dx-workflow-card bl-block-module">
        <div class="bl-text-align--center">
          <img src="assets/images/checklist.svg" alt="" aria-hidden="true">
        </div>
      <div>
        <p *ngIf="!!checklistDescription" class="bl-margin--0 bl-overflow-wrap--break-word" [innerHtml]="checklistDescription | safe: 'html'" ></p>
      </div>
      </div>
    </div>
    <cu-dynamic-page-action-bar [page]="page" [flow]="flow"></cu-dynamic-page-action-bar>
  </div>
</cu-dynamic-page-layout>